import { z } from 'zod';
export const MEDIA_KINDS = ['image', 'video'];
export const MEDIA_STATUSES = ['processing', 'ready', 'failed'];
export const FAILURE_REASONS = [
    'too_long',
    'video_not_allowed',
    'unsupported_type',
    'too_large',
    'limit_reached',
    'processing_error',
];
export const FAILURE_MESSAGES = {
    too_long: 'Video is longer than this event allows',
    video_not_allowed: 'Videos are turned off for this event',
    unsupported_type: 'That file type is not supported',
    too_large: 'That file is too large',
    // Plan-neutral: the guest page says the number, which it knows from the session.
    limit_reached: 'This wall has reached its photo limit',
    processing_error: 'Something went wrong processing this file',
};
export const uploadFieldsSchema = z.object({
    uploaderName: z.string().trim().max(60).optional(),
});
export const mediaFilters = ['all', 'visible', 'hidden', 'failed'];
//# sourceMappingURL=media.js.map